import { Component, OnInit } from '@angular/core';

import { ProfissionalService } from '../../../services/profissional.service';

import { AuthService } from '../../../services/auth.service';
@Component({
  selector: 'app-condutoresprint',
  templateUrl: './condutoresprint.component.html',
  styleUrls: ['./condutoresprint.component.css']
})
export class CondutoresprintComponent implements OnInit {

  public profissionais = [];

  constructor(
    private authSvc: AuthService,
    private profissionalSvc: ProfissionalService
    ) { }

  ngOnInit() {
    this.pegaCondutores(this.authSvc.getUsuarioId());

  }

  pegaCondutores(usuario_id){
    this.profissionalSvc.getRelatorioCondutores(usuario_id).then((data: any) => {
			this.profissionais = data;
    }).catch((err) => console.log(err));
  }
}
